const defaultHead = require(`@/assets/img/default-head.jpg`);
const phoneHead = require(`@/assets/img/phone-head.png`);
import { ENV_CONFIG } from '@/config';
const getters = {
  status(state) {
    return state.status;
  },
  type(state) {
    return state.type;
  },
  corpId(state) {
    return state.corpId;
  },
  channelInfo(state) {
    let info = JSON.parse(JSON.stringify(state.channelInfo || {}));
    if (!info.defaultUserAva) {
      info.defaultUserAva = defaultHead;
    }
    if (!info.chatAdminAvaUrl) {
      info.chatAdminAvaUrl = defaultHead;
    }
    info.defaultPhoneHeadAva = phoneHead;
    return info;
  },
  menuList(state) {
    return state.menuList;
  },
  menuListPc(state) {
    return state.menuList.filter(obj => {
      return obj.menuType !== 'chat' && obj.menuType !== 'playbill';
    });
  },
  playerInfo(state) {
    return state.playerInfo;
  },
  wechatInfo(state) {
    return state.wechatInfo;
  },
  userInfo(state) {
    return state.userInfo;
  },
  uuid(state) {
    return state.uuid;
  },
  jumpUrls(state) {
    let info = state.channelInfo;
    let uin = info.uin;
    let id = info.id;
    let backUrl = encodeURIComponent(window.location.href);
    let origin =
      ENV_CONFIG.NODE_ENV === 'development'
        ? `http://${window.location.hostname}:3004`
        : window.location.origin;
    return {
      login: `${origin}/my/login?uin=${uin}&backUrl=${backUrl}`,
      login_binding: `${origin}/my/login/binding?uin=${uin}&backUrl=${backUrl}`,
      center: `${origin}/my/center?uin=${uin}&backUrl=${backUrl}`,
      center_wallet: `${origin}/my/center/wallet?uin=${uin}&backUrl=${backUrl}`,
      pay_redPacket: `${origin}/my/pay/redPacket?uin=${uin}&id=${id}&backUrl=${backUrl}`
    };
  },
  playerAddress(state) {
    return state.playerAddress;
  },
  // js-bridge v2 存在于cookie中的受限模式状态
  isOpenLimitedMode() {
    try {
      return window._gdyJsConfig.isOpenLimitedMode
    } catch (e) {
      return false
    }
  },
  globalSetting(state) {
    return state.globalSetting
  },
  isDMSLinked(state) {
    return state.isDMSLinked
  },
  drainage(state) {
    return state.drainage || {}
  },
};
export default getters;
